import { IDownloadContratoArquivoUseCase } from "../../../presentation/useCases/read/download_contrato_arquivo_use_case";
import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

export class DownloadContratoArquivoUseCase implements IDownloadContratoArquivoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async downloadContratoArquivo(
    idContratoArquivo: number,
    nomeArquivo: string,
  ): Promise<void> {
    const blob =
      await this.repository.downloadContratoArquivo(idContratoArquivo);
    if (!blob) throw new Error("Falha ao buscar dados da imagem!");

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", String(nomeArquivo));
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
  }
}
